export default "__VITE_ASSET__CLhqFOPJ__"